import * as React from 'react';

function SvgCalendarGray(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#calendar-gray_svg__a)">
        <path
          d="M12.75 1.877h-2.625v-1A.125.125 0 0010 .752h-.875A.125.125 0 009 .877v1H5v-1a.125.125 0 00-.125-.125H4a.125.125 0 00-.125.125v1H1.25a.5.5 0 00-.5.5v10.375a.5.5 0 00.5.5h11.5a.5.5 0 00.5-.5V2.377a.5.5 0 00-.5-.5zm-.625 10.25H1.875V6.189h10.25v5.938zm-10.25-7V3.002h2v.75c0 .069.056.125.125.125h.875A.125.125 0 005 3.752v-.75h4v.75c0 .069.056.125.125.125H10a.125.125 0 00.125-.125v-.75h2v2.125H1.875z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="calendar-gray_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCalendarGray;
